<template>
    <el-button type="primary"  icon="el-icon-edit-outline" v-on:click="clickEvent()">生成报表</el-button>
</template>
  
  <script>
  
  export default {
    name: 'create-form-button',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// CreateFormButton.vue?42450f27